import React from 'react';
import SetProductSerialNumberModal from './SetProductSerialNumberModal';
import APIServicesRegistry from '@lib/api-services/APIServicesRegistry';
import ProjectConfigurationsApiService from '@lib/api-services/ProjectConfigurationsApiService';

export default class SetProductSerialNumberForNewModal extends SetProductSerialNumberModal {

    constructor(props) {
        super(props);
        this.state = {
            productSerialNumber: props.productSerialNumber
        }
    }

    onSaveClick = () => {
        const api = APIServicesRegistry.getService(ProjectConfigurationsApiService);
        api.verifyProductSerialNumberUniquess(this.state.productSerialNumber).then(() => {
            if (this.props.onSuccess) {
                this.props.onSuccess(this.state.productSerialNumber);
            }
        })
    }
}